import { acceptHMRUpdate, defineStore } from 'pinia'
import { ref, watch } from 'vue'
import { useMediaQuery } from '@vueuse/core'
import { MediaQuery } from '@cplug/design-system/components/props'

const useMenuSidebarStore = defineStore('menu/sidebar', () => {
  const isDesktop = useMediaQuery(MediaQuery.DesktopWithSidebar)

  const isOpen = ref<boolean>(true)
  const isPrimarySidebarExpanded = ref<boolean>(false)
  const isSecondaryPanelOpen = ref<boolean>(true)
  const isSecondaryPanelExpanded = ref<boolean>(true)
  const totalSidebarWidth = ref<number>(335)
  const assistantSidebarWidth = ref<number>(0)
  const assistantHidesMenu = ref<boolean>(false)

  function syncMenuOpenState (): void {
    if (!isDesktop.value || assistantHidesMenu.value) {
      isOpen.value = false
      return
    }

    isOpen.value = true
  }

  watch(
    () => isDesktop.value,
    () => { syncMenuOpenState() },
    { immediate: true }
  )

  function open (): void {
    isOpen.value = true
  }

  function close (): void {
    isOpen.value = false
  }

  function toogle (): void {
    isOpen.value = !isOpen.value
  }

  function expandPrimarySidebar (): void {
    isPrimarySidebarExpanded.value = true
  }

  function collapsePrimarySidebar (): void {
    isPrimarySidebarExpanded.value = false
  }

  function setTotalSidebarWidth (width: number): void {
    totalSidebarWidth.value = width
  }

  function setAssistantSidebarWidth (width: number): void {
    assistantSidebarWidth.value = width
  }

  function setAssistantHidesMenu (hides: boolean): void {
    assistantHidesMenu.value = hides
    syncMenuOpenState()
  }

  function openSecondaryPanel (): void {
    isSecondaryPanelOpen.value = true
    isSecondaryPanelExpanded.value = true
  }

  function closeSecondaryPanel (): void {
    isSecondaryPanelOpen.value = true
    isSecondaryPanelExpanded.value = false
  }

  function toggleSecondaryPanel (): void {
    isSecondaryPanelOpen.value = true
    isSecondaryPanelExpanded.value = !isSecondaryPanelExpanded.value
  }

  return {
    isOpen,
    open,
    close,
    toogle,
    isPrimarySidebarExpanded,
    expandPrimarySidebar,
    collapsePrimarySidebar,
    isSecondaryPanelOpen,
    isSecondaryPanelExpanded,
    openSecondaryPanel,
    closeSecondaryPanel,
    toggleSecondaryPanel,
    totalSidebarWidth,
    setTotalSidebarWidth,
    assistantSidebarWidth,
    setAssistantSidebarWidth,
    assistantHidesMenu,
    setAssistantHidesMenu
  }
})

export default useMenuSidebarStore

/* c8 ignore next 3 */
if ((import.meta as any).hot) {
  (import.meta as any).hot.accept(acceptHMRUpdate(useMenuSidebarStore, (import.meta as any).hot))
}
